import { FormattingSettingsOptions } from './formatting-settings.types';

export const FeetInchUnit = 'ft-in';

export const presetDisplayModes: Record<string, FormattingSettingsOptions> = {
  full: {
    enableCustomSystem: true,
    enableUnitSystemSelection: true,
    enableUnitSelection: true,
    enablePrecisionSelection: true,
    enableDescriptions: false,
  },
  systemOnly: {
    enableCustomSystem: false,
    enableUnitSystemSelection: true,
    enableUnitSelection: false,
    enablePrecisionSelection: false,
    enableDescriptions: true,
  },
  systemAndPrecision: {
    enableCustomSystem: false,
    enableUnitSystemSelection: true,
    enableUnitSelection: false,
    enablePrecisionSelection: true,
    enableDescriptions: false,
  },
  readOnly: {
    enableCustomSystem: false,
    enableUnitSystemSelection: false,
    enableUnitSelection: false,
    enablePrecisionSelection: false,
    enableDescriptions: false,
  },
};
